import {Directive, ElementRef} from "@angular/core";

@Directive(
  {
    selector: '[game-body]'
  })
export class GameBodyDirective {
  constructor(el: ElementRef) {
    el.nativeElement.style.backgroundColor = '#223823';
  }
}
